// Added by Sejune Oh on 2020-03-02
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    IconButton as MaterialUIIconButton,
    IconButtonProps as MaterialUIIconButtonProps
} from '@material-ui/core'

interface IconButtonBaseProps { }
export type IconButtonProps = Partial<MaterialUIIconButtonProps> & IconButtonBaseProps

export const IconButton: FC<IconButtonProps> = ({ ...props }) => {
    return <MaterialUIIconButton {...props}></MaterialUIIconButton>
}
